import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ProductTagState = readonly string[];

export const PRODUCT_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductTagState>>,
): ConditionType<ProductTagState, ModelCondition.ProductTag> => ({
  name: "Product tags",
  description(state) {
    return `Product tags: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: ModelCondition.ProductTag) {
    return model.tags;
  },
  toModel(state) {
    return { type: ModelCondition.PRODUCT_TAG, tags: state };
  },
  valid() {
    return true;
  },
});
